import React from 'react';
import { GovernanceTaxonomyManagementProvider } from './GovernanceTaxonomyManagementContext';
import { useGovernanceRouteSync } from './useGovernanceRouteSync';
import { GovernanceTaxonomySidebar } from './Components/GovernanceTaxonomySidebar';
import { GovernanceTaxonomyManagementContent } from './Components/GovernanceTaxonomyManagementContent';

export function GovernanceTaxonomyManagement() {
  useGovernanceRouteSync({
    embedPrefix: '/brand-presence/settings/taxonomies',
    appPrefix: '/brand-presence/settings/taxonomies',
  });

  return (
    <GovernanceTaxonomyManagementProvider>
      <div className="w-full flex flex-col md:flex-row bg-white">
        <GovernanceTaxonomySidebar />
        {/* The screen's column: its padding sits on the screen's own main, and nothing here scrolls; the page does. */}
        <div className="relative isolate min-w-0 flex-1 bg-slate-50 bg-brand-page">
          <GovernanceTaxonomyManagementContent />
        </div>
      </div>
    </GovernanceTaxonomyManagementProvider>
  );
}
